
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/detail/[slug]",
      function () {
        return require("private-next-pages/detail/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/detail/[slug]"])
      });
    }
  